import React from 'react';

import { Paper, Tab, Tabs } from '@mui/material';

import TabStripLabel from './TabStripLabel';

interface Props<TabValue extends string> {
  activeTab: TabValue;
  counts: Partial<Record<TabValue, number>>;
  isErrorCounts?: boolean;
  onTabChange: (tab: TabValue) => void;
  tabs: ReadonlyArray<{ label: string; value: TabValue }>;
}

/** URL-tab-strip shell shared across Offer Builder sub-features (Deal Information, Pricing Tool). */
export default function TabStrip<TabValue extends string>({
  activeTab,
  counts,
  isErrorCounts = false,
  onTabChange,
  tabs,
}: Props<TabValue>) {
  return (
    <Paper sx={{ position: 'sticky', top: 0, zIndex: 2 }}>
      <Tabs
        allowScrollButtonsMobile
        scrollButtons="auto"
        value={activeTab}
        variant="scrollable"
        onChange={(_event, value: TabValue) => onTabChange(value)}
      >
        {tabs.map((tab) => (
          <Tab
            key={tab.value}
            label={<TabStripLabel count={counts[tab.value]} isError={isErrorCounts} label={tab.label} />}
            value={tab.value}
          />
        ))}
      </Tabs>
    </Paper>
  );
}
